import * as actionTypes from "./actionTypes";

export const showType = (obj) =>  {
    return {
        type: actionTypes.SHOW,
        payload: {
            type: obj.type,
            selectedNumber: obj.selectedNumber
        }
    }
}

export const showCollection = (obj) =>  {
    return {
        type: actionTypes.SHOW_COLLECTION,
        payload: {
            type: obj.type,
            collection: obj.collection
        }
    }
}

export const hideCollection = (obj) =>  {
    return {
        type: actionTypes.HIDE_COLLECTION,
        payload: {
            type: obj.type,
            collection: obj.collection
        }
    }
}

export const incrementCounter = (type) =>  {
    return {
        type: actionTypes.INCREMENT_SNACKBAR_COUNTER,
        payload: {
            type
        }
    }
}

export const resetSnackbarCounter = (type) =>  {
    return {
        type: actionTypes.RESET_SNACKBAR_COUNTER,
        payload: {
            type
        }
    }
}


export const closeSnackbar = () =>  {
    return {
        type: actionTypes.CLOSE_SNACKBAR
    }
}
